export const ADD_TO_CART = "ADD_TO_CART"
export const INCREASE_ITEM = "INCREASE_ITEM"
export const DECREASE_ITEM = "DECREASE_ITEM"
export const REMOVE_FROM_CART = "REMOVE_FROM_CART"
export const CLEAR_CART = "CLEAR_CART"
export const CLEAR_PURCHASE = "CLEAR_PURCHASE"
export const GET_TOTAL = "GET_TOTAL"
export const SET_INVOICE_NO = "SET_INVOICE_NO"
export const SIGN_IN = "SIGN_IN"
export const SIGN_OUT = "SIGN_OUT"
export const CHECK_USER = "CHECK_USER"
